import { useReactiveVar } from "@apollo/client";
import { Flex, Icon } from "@chakra-ui/react";
import { AiOutlineDashboard } from "react-icons/ai";
import { CiPen } from "react-icons/ci";
import { HiOutlineClipboardList } from "react-icons/hi";
import { Navigate } from "react-router-dom";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { MenuTile } from "../../components/menuTile/MenuTile";
import {
  AccountsUserRoleChoices,
} from "../../graphql/generated";
import { userDetailsVar } from "../../lib/cache";

// export enum PageRedirect {
//   buyer = "BUYER",
//   publisher = "PUBLISHER",
// }

export const LandingPage = () => {
  const currentUser = useReactiveVar(userDetailsVar);

  if (!currentUser) {
    return <ComponentLoading />;
  }

  // const pageRedirect = localStorage.getItem("@buyer_or_publisher");
  // if (pageRedirect === PageRedirect.publisher) {
  //   return <Navigate to={"/publisher"} />;
  // }

  // Staff users directed to buyer dashboard campaigns list page
  if (currentUser?.isStaff) {
    return <Navigate to={"./campaigns"} />;
  }

  //Buyers directed to buyer dashboard
  if (
    currentUser.role === AccountsUserRoleChoices.Buyer
  ) {
    return <Navigate to={"./campaigns"} />;
  }

  // User role is Publisher direct to publisher dashboard
  // segments list page
  if (currentUser.role === AccountsUserRoleChoices.Publisher) {
    return <Navigate to={"./publisher"} />;
  }

  return (
    <Flex
      width={"90%"}
      mx={"auto"}
      flexDir={"row"}
      flexWrap={"wrap"}
      gridGap={6}
      p={6}
    >
      <MenuTile
        pageName={"Campaigns"}
        icon={<Icon as={HiOutlineClipboardList} w={20} h={20} />}
        pageUrl={"/campaigns"}
      />
      {currentUser.isStaff && (
        <MenuTile
          pageName={"Admin Dashboard"}
          icon={<Icon as={AiOutlineDashboard} w={20} h={20} />}
          pageUrl={"/admin-dashboard"}
          isAdmin={true}
        />
      )}
      {(currentUser.isStaff || currentUser.agency.partner) && (
        <MenuTile
          pageName={"Publishers"}
          icon={<Icon as={CiPen} w={20} h={20} strokeWidth={1} />}
          pageUrl={"./publisher"}
        />
      )}
      {/* {(currentUser.isStaff || currentUser.agency.partner) && (
        <MenuTile
          pageName={"Human in the Loop"}
          icon={<Icon as={ImLoop} w={20} h={20} />}
          pageUrl={"/human-in-the-loop"}
        />
      )}
      {(currentUser.isStaff || currentUser.agency.partner) && (
        <MenuTile
          pageName={"Segments"}
          icon={<Icon as={FaChartPie} w={20} h={20} />}
          pageUrl={"/segments"}
        />
      )} */}
    </Flex>
  );
};
